module.exports = __webpack_public_path__ + "img/domicilio.397e2a3a.svg";